<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="facilitySetupForm" :refresh-key="refreshKey" :show-expand="false" :has-import="true" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                facilitySetupForm: () => import('../forms/FacilitySetupForm'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Facility', value: 'facilityId', table: 'facilities', form: () => import('../forms/FacilityForm') },
                    { text: 'Staff Member', value: 'staffMemberId', table: 'staffMembers', form: () => import('../forms/StaffMemberForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    facilities: [],
                    staffMembers: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "facilityId", direction: "ascending" },
                    { column: "staffMemberId", direction: "ascending" },
                ],
                itemsField: 'facilitySetups',
                editPageName: 'facilitySetup',
                apiMethod: 'FacilitySetups',
                claimName: 'FacilitySetups',
                formTitle: 'Facility Setup',
                excelTitle: 'Facility Setups',
                hasEditPage: false,
            }
        },
    };
</script>
